import { EngineService } from '@/services/engine';
import type { VehicleOccurrence } from '@/types/vehicle';
import { useOccurrences } from './useOccurrences';

interface UseVehicleOccurrencesParams {
    vehicleId: string | undefined;
    pageSize?: number;
}

export function useVehicleOccurrences({
    vehicleId,
    pageSize,
}: UseVehicleOccurrencesParams) {
    return useOccurrences<VehicleOccurrence>({
        entityId: vehicleId,
        cacheKeyPrefix: 'vehicle-occurrences',
        fetcher: (id, params) =>
            EngineService.getVehicleOccurrences(id, params),
        pageSize,
    });
}
